import React from "react";
import * as Yup from "yup";

const validationSchema = Yup.object({
    name: Yup.string().required('Validation name is required'),
    description: Yup.string().required('Description is required'),
    script_name: Yup.string().required('Script name is required'),
  });

  export default validationSchema;